import React from 'react';
import { GelRowLayout, GelColumnLayout, GelContainerLite } from '@tal-gel/components';
import { formatDateTime } from '../Shared/Text';
import { get, has, isEmpty } from 'lodash';
import { defaultH3Text, boldLabel, defaultFontText, subSectionTitle, subSectionTopLine, subSectionMinHeight } from '../Shared/Styles';

export default function PaymentDetails(props) {
    let paymentDetail;

    if (!props.paymentDetails || isEmpty(props.paymentDetails)) {
        paymentDetail = [0];
    } else {
        const maxPartyPaymentNumber = props.paymentDetails.reduce(
            (max, character) => (character.partyPaymentNumber > max.partyPaymentNumber ? character : max),
            props.paymentDetails[0]
          );

        paymentDetail = maxPartyPaymentNumber;
    }

    return (
        <GelContainerLite style={subSectionMinHeight}>
            <hr style={subSectionTopLine}/>
            <GelRowLayout gutter="medium" style={subSectionTitle}>
                <h3 style={defaultH3Text} data-testid="currentPaymentLabel">Current payment method</h3>
            </GelRowLayout>
            <GelRowLayout gutter="medium" style={defaultFontText}>
                <GelColumnLayout distribution="1/3 2/3">
                    <GelRowLayout gutter="small">
                        <GelColumnLayout distribution="1/2 1/2">
                            <div style={boldLabel}>Frequency</div>
                            <div style={boldLabel}>Instalment Premium</div>
                        </GelColumnLayout>
                    </GelRowLayout>
                    <GelRowLayout gutter="smalsl">
                        <GelColumnLayout distribution="1/4 1/4 1/4 1/4">
                            <div style={boldLabel}>Next Bill Date</div>
                            <div style={boldLabel}>Paid To Date</div>
                            <div style={boldLabel}>Payer</div>
                            <div style={boldLabel}>Payment Method</div>
                        </GelColumnLayout>
                    </GelRowLayout>
                </GelColumnLayout>
            </GelRowLayout>

            <GelRowLayout gutter="medium" style={defaultFontText}>
                <GelColumnLayout distribution="1/3 2/3">
                    <GelRowLayout gutter="small">
                        <GelColumnLayout distribution="1/2 1/2">
                            <div data-testid="paymentFrequency">{get(paymentDetail, 'paymentFrequency', '')}</div>
                            <div data-testid="installmentPremium">
                            {(has(paymentDetail, 'installmentPremium') && paymentDetail.installmentPremium != null) ? '$' + paymentDetail.installmentPremium.toLocaleString() : ""}
                            </div>
                        </GelColumnLayout>
                    </GelRowLayout>
                    <GelRowLayout gutter="smalsl">
                        <GelColumnLayout distribution="1/4 1/4 1/4 1/4">
                            <div data-testid="nextBillDate">{has(paymentDetail, 'nextBillDate')  && paymentDetail.nextBillDate!==null ?
                                (formatDateTime(paymentDetail.nextBillDate)) : ""}</div>
                            <div data-testid="paidToDate">{has(paymentDetail, 'paidToDate') && paymentDetail.paidToDate!==null ?
                                (formatDateTime(paymentDetail.paidToDate)) : ""}</div>
                            <div data-testid="payerName">{get(paymentDetail.payer, 'payerName', '')}</div>
                            <div data-testid="paymentMethod">{
                                get(paymentDetail, 'paymentMethod', '') === 'Credit Card' ?
                                paymentDetail.paymentMethod.concat(" ending with ", paymentDetail.creditCardNumber.slice(-4), " exp: ", paymentDetail.cardExpiryDate.slice(5,7) , '/', paymentDetail.cardExpiryDate.slice(2,4))
                                : get(paymentDetail, 'paymentMethod', '') === 'Direct Debit' ? 
                                paymentDetail.paymentMethod.concat(" BSB: ", paymentDetail.bSB, " ", paymentDetail.accountNo)
                                : (has(paymentDetail, 'paymentMethod') && paymentDetail.paymentMethod != null) ? paymentDetail.paymentMethod : ""
                                }</div>
                        </GelColumnLayout>
                    </GelRowLayout>
                </GelColumnLayout>
            </GelRowLayout>

            <GelRowLayout gutter="medium" style={subSectionTitle}>
                <h3 style={defaultH3Text}>Total annualised premium</h3>
            </GelRowLayout>

            <GelRowLayout gutter="medium" style={defaultFontText}>
                <GelColumnLayout distribution="1/3 2/3">
                    <GelRowLayout gutter="small">
                        <GelColumnLayout distribution="1/2 1/2">
                            <div style={boldLabel}>Annual Premium</div>
                            <div style={boldLabel}>Policy Fee</div>
                        </GelColumnLayout>
                    </GelRowLayout>
                    <GelRowLayout gutter="smalsl">
                        <GelColumnLayout distribution="1/4 1/4 2/4">
                            <div style={boldLabel}>Stamp Duty</div>
                        </GelColumnLayout>
                    </GelRowLayout>
                </GelColumnLayout>
            </GelRowLayout>

            <GelRowLayout gutter="medium" style={defaultFontText}>
                <GelColumnLayout distribution="1/3 2/3">
                    <GelRowLayout gutter="small">
                        <GelColumnLayout distribution="1/2 1/2">
                            <div data-testid="annualPremium">
                            {(has(paymentDetail, 'annualPremium') && paymentDetail.annualPremium != null) ? '$' + paymentDetail.annualPremium.toLocaleString("en-AU", { minimumFractionDigits: 2 }) : ""}
                            </div>
                            <div data-testid="policyFee">
                            {(has(paymentDetail, 'policyFee') && paymentDetail.policyFee != null) ? '$' + paymentDetail.policyFee.toLocaleString("en-AU", { minimumFractionDigits: 2 }) : ""}
                            </div>
                        </GelColumnLayout>
                    </GelRowLayout>
                    <GelRowLayout gutter="smalsl">
                        <GelColumnLayout distribution="1/4 1/4 2/4">
                            <div data-testid="stampDuty">
                            {(has(paymentDetail, 'stampDuty') && paymentDetail.stampDuty != null) ? '$' + paymentDetail.stampDuty.toLocaleString("en-AU", { minimumFractionDigits: 2 }) : ""}
                            </div>
                        </GelColumnLayout>
                    </GelRowLayout>
                </GelColumnLayout>
            </GelRowLayout>
            <div><span style={boldLabel}>Disclaimer: </span>Annual Premium is inclusive of stamp duty (if applicable to the policy)</div>
        </GelContainerLite>
    );

}